import { render, staticRenderFns } from "./billPaymentModal.vue?vue&type=template&id=b12033d0&scoped=true"
import script from "./billPaymentModal.vue?vue&type=script&lang=js"
export * from "./billPaymentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12033d0",
  null
  
)

export default component.exports